'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _apiHelper = require('api/api-helper');

var _selectors = require('selectors');

var _profilesDataActions = require('actions/profilesDataActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchProfilesData);

// Get the profile that belongs to the user customer
// and send SF profile id to Heap Analytics
var sendToHeap = function sendToHeap(profilesArray, userCustomerId) {
    var userProfile = profilesArray.find(function (x) {
        return x.customer_id === userCustomerId;
    });
    if (window.heap && userProfile) {
        if (userProfile.id) {
            window.heap.identify(userProfile.id);
        }
    }
};

function fetchProfilesData() {
    var authToken, locale, userCustomerId, customerIds, partialProfileData, errorMessage, i, error, profileIds, profilesData, _i;

    return _regenerator2.default.wrap(function fetchProfilesData$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.take)(_profilesDataActions.PROFILES_DATA_REQUESTED);

                case 2:
                    _context.next = 4;
                    return (0, _effects.select)(function (state) {
                        return state.user.authorization.token;
                    });

                case 4:
                    authToken = _context.sent;
                    _context.next = 7;
                    return (0, _effects.select)(function (state) {
                        return state.intl.locale;
                    });

                case 7:
                    locale = _context.sent;
                    _context.next = 10;
                    return (0, _effects.select)(function (state) {
                        return state.user.customerId;
                    });

                case 10:
                    userCustomerId = _context.sent;
                    // provided if G Account or app's login flow

                    customerIds = [];

                    if (!userCustomerId) {
                        _context.next = 16;
                        break;
                    }

                    // If a user is logged in we only fetch their profile for their notification preferences
                    customerIds = [userCustomerId];
                    _context.next = 19;
                    break;

                case 16:
                    _context.next = 18;
                    return (0, _effects.select)(_selectors.getCustomerIds);

                case 18:
                    customerIds = _context.sent;

                case 19:
                    _context.next = 21;
                    return customerIds.map(function (customerId) {
                        return (0, _effects.call)(_apiHelper.getProfileData, customerId, authToken, locale);
                    });

                case 21:
                    partialProfileData = _context.sent;
                    errorMessage = void 0;
                    i = 0;

                case 24:
                    if (!(i < partialProfileData.length)) {
                        _context.next = 32;
                        break;
                    }

                    error = partialProfileData[i].error;
                    // const { profileData } = partialProfileData[i]

                    if (!error) {
                        _context.next = 29;
                        break;
                    }

                    // Call to API for partialProfilesArray fails
                    errorMessage = error._error;
                    return _context.abrupt('break', 32);

                case 29:
                    i++;
                    _context.next = 24;
                    break;

                case 32:
                    if (!errorMessage) {
                        _context.next = 37;
                        break;
                    }

                    _context.next = 35;
                    return (0, _effects.put)((0, _profilesDataActions.profilesDataRequestFailed)(errorMessage));

                case 35:
                    _context.next = 58;
                    break;

                case 37:
                    // we expect the array (results) in partialProfile's profileData to be length 1 or 0 (will catch error above if 0)
                    profileIds = partialProfileData.map(function (partialProfile) {
                        return partialProfile.profileData[0] && partialProfile.profileData[0].id;
                    });
                    _context.next = 40;
                    return profileIds.map(function (profileId) {
                        return (0, _effects.call)(_apiHelper.getResourceData, profileId, 'profiles', authToken, locale);
                    });

                case 40:
                    profilesData = _context.sent;
                    _i = 0;

                case 42:
                    if (!(_i < profilesData.length)) {
                        _context.next = 50;
                        break;
                    }

                    error = profilesData[_i].error;

                    if (!error) {
                        _context.next = 47;
                        break;
                    }

                    // Call to API for profileData fails
                    errorMessage = error._error;
                    return _context.abrupt('break', 50);

                case 47:
                    _i++;
                    _context.next = 42;
                    break;

                case 50:
                    if (!errorMessage) {
                        _context.next = 55;
                        break;
                    }

                    _context.next = 53;
                    return (0, _effects.put)((0, _profilesDataActions.profilesDataRequestFailed)(errorMessage));

                case 53:
                    _context.next = 58;
                    break;

                case 55:
                    _context.next = 57;
                    return (0, _effects.put)((0, _profilesDataActions.profilesDataReceived)(profilesData.map(function (x) {
                        return x.resourceData;
                    })));

                case 57:
                    if (profilesData && userCustomerId) {
                        sendToHeap(profilesData.map(function (x) {
                            return x.resourceData;
                        }), userCustomerId);
                    }

                case 58:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

exports.default = fetchProfilesData;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/fetchProfilesData.js
// module id = 1415
// module chunks = 0